<template>
    <section class="q10__page my-14">
        <div class="container px-11 2xl:px-3 m-auto">
            <div class="q10__article_container__title_head">
                <!-- article title head -->
                <article-title-head
                    :options="{
                        category: currentPage.content.sCategory.text,
                        phrase: currentPage.content.sPhrase.text,
                        author: currentPage.content.sAuthor.text,
                        from: currentPage.content.nFrom.text,
                        to: currentPage.content.nTo.text,
                        color: 'text-selective_yellow',
                    }"
                ></article-title-head>
            </div>

            <div class="q10__article_container__content">
                <div
                    class="
                        q10__article_container__content__vertical_head
                        mx-auto
                        relative
                    "
                >
                    <div class="relative">
                        <article-vertical-head
                            :options="{
                                text: currentPage.content.oVerticalHead.text,
                                position: 'lg:ml-1',
                                imageAuthor:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.image1.src,
                            }"
                        ></article-vertical-head>

                        <hotspot-richmedia
                            :options="{
                                icon: 'diaporama',
                                collection: getRichmediaByCollection(
                                    currentPage,
                                    'Interview de P. Guichon'
                                ),
                            }"
                            class="top-6 right-1 lg:right-6"
                        />
                    </div>
                </div>

                <div class="q10__article_container__content__paragraphs">
                    <paragraph-first-letter-big
                        :options="{
                            letter: currentPage.content.firstParagraph.text.substr(
                                0,
                                1
                            ),
                            color: 'text-selective_yellow',
                        }"
                    />

                    <paragraph :options="{}">
                        <span
                            v-html="
                                currentPage.content.firstParagraph.text.slice(1)
                            "
                        ></span>
                        <!-- <square
                            :options="{
                                from: 'from-selective_yellow',
                                to: 'to-selective_orange',
                            }"
                        /> -->
                    </paragraph>
                </div>
            </div>
        </div>

        <timeline-carousel
            :options="{
                timeline: currentPage.timeline,
            }"
        />

        <div class="container px-11 2xl:px-3 m-auto">
            <div class="relative">
                <image-with-descriptions
                    :options="{
                        image:
                            'pages/' +
                            currentPage.slug +
                            '/' +
                            currentPage.images.image2.src,
                        descriptions: [
                            {
                                text: currentPage.images.image2.text,
                                position: 'bottom-right', // top/bottom-left/right
                                orientation: 'horizontal', // vertical, horizontal
                            },
                        ],
                    }"
                />

                <hotspot-richmedia
                    :options="{
                        icon: 'diaporama',
                        collection: getRichmediaByCollection(
                            currentPage,
                            'La vidange du lac glaciaire de Rochemelon'
                        ),
                    }"
                    class="top-2 right-2"
                />
            </div>

            <article-note
                :options="{
                    verticalcontent: currentPage.content.verticalContent.text,
                    title: currentPage.content.sTitle.text,
                    content: currentPage.content.secondParagraph.text,

                    color: {
                        verticalcontent: 'text-cornflower_blue',
                        title: 'text-selective_yellow',
                        content: 'text-nandor',
                    },
                    fontSize: {
                        verticalcontent: 'text-4xl md:text-4xl lg:text-4xl',
                        title: 'text-4xl md:text-3xl lg:text-4xl',
                        content: 'text-md md:text-xl lg:text-xl',
                    },
                    margin: {
                        verticalcontent: 'mt-1',
                    },
                }"
            />
        </div>
    </section>
</template>

<script>
import PagesMixin from "@/mixins/PagesMixin";
import Paragraph from "../../components/Paragraph.vue";

export default {
    components: { Paragraph },
    name: "PageTest",
    mixins: [PagesMixin],
};
</script>

<style scoped lang='scss'>
.article_note {
    @apply overflow-visible;
}

.q10__article_container {
    &__title_head {
        @apply lg:mb-1;
    }

    &__content {
        @apply flex flex-col lg:flex-row justify-center;

        &__vertical_head {
            @apply col-auto;
        }

        &__paragraphs {
            @apply col-auto mt-3;
        }
    }

    &__content__paragraphs {
        p {
            @apply text-nandor;
        }
    }
}
</style>